import { Button, Form, Input, Select, message, Space } from "antd";
import { serverFetch } from "../../server";
import { useState, useEffect } from "react";
import { dictsGetUsers } from "../../extensions/dicts";
import { isMobile } from "../../extensions/design";

const ClientAbonUsageChange = ({ usage, onClose }) => {
const [form] = Form.useForm();
const [users, setUsers] = useState([]);
const [loading, setLoading] = useState(false);
const [usageItems, setUsageItems] = useState(usage);

  const onSave = () => {
    setLoading(true);
    serverFetch("sale/Use", { method: "PUT", bodyData: usageItems })
      .then(() => {
        onClose(true);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const onCancel = () => { onClose(usageItems) };

  useEffect(() => {
    form.setFieldsValue(usage);
    setUsageItems(usage)
    dictsGetUsers(setUsers)
  }, [usage]);

  const onValuesChange = value => setUsageItems({...usageItems, ...value});

  return !isMobile ? 
    <Form form={form} colon={false} labelCol={{ span: 5 }} wrapperCol={{ span: 24 }} loading={loading} onValuesChange={onValuesChange}>
      <Form.Item label="Количество" name="qty" wrapperCol={{ span: 4 }}><Input/></Form.Item>
      <Form.Item label="Исполнитель" name="userId" wrapperCol={{ span: 24 }}><Select options={users}/></Form.Item>
      <Form.Item label=" " labelCol={{ span: 16 }} style={{marginTop:"16px", marginBottom:"16px"}}>
        <Space>
          <Button onClick={onSave}>Сохранить</Button>
          <Button onClick={onCancel}>Отмена</Button>
        </Space>
      </Form.Item>
    </Form>
    :     
    <Form form={form} layout="inline" colon={false} labelCol={{ flex: "100px" }} wrapperCol={{ flex: "1" }} className="client-subitem-content" loading={loading} onValuesChange={onValuesChange}>
      <Form.Item label="Количество" name="qty" style={{width:"100%"}}><Input/></Form.Item>
      <Form.Item label="Исполнитель" name="userId" className="client-abon-form-item-with-margin"><Select style={{width:"100%"}} options={users}/></Form.Item>
      <Button style={{width: "49%", marginRight: "2%", marginTop: 6}}onClick={onSave}>Сохранить</Button>
      <Button style={{width: "49%", marginTop: 6}} onClick={onCancel}>Отмена</Button>
    </Form>
};
export default ClientAbonUsageChange;
